import {useState} from 'react';
import {useMutation} from '@apollo/client';
import {Redirect} from 'react-router-dom';
import {createOrgPath} from '@core/lib/organizations';
import {ToastMessage} from '@core/ui/Alert';
import {Card, CardHeader} from '@core/ui/Content';
import ResponsiveContent from '@core/ui/ResponsiveContent';
import PixelForm from '@analytics/components/pixels/PixelForm';
import UPDATE_PIXEL_MUTATION from '@analytics/graphql-api/_old_mutations/UpdatePixel';
import ORGANIZATION_KEY_QUERY from '@analytics/graphql-api/_old_queries/OrganizationKeyQuery';
import ORGANIZATION_QUERY from '@analytics/graphql-api/_old_queries/OrganizationQuery';
import {ManagePixelsPixelRouteProps} from './_routes';

export function PixelUpdate({
  organization,
  pixel,
}: ManagePixelsPixelRouteProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [complete, setCompleted] = useState(false);

  const [updatePixel] = useMutation(UPDATE_PIXEL_MUTATION, {
    refetchQueries: [ORGANIZATION_QUERY, ORGANIZATION_KEY_QUERY],
    awaitRefetchQueries: true,
  });

  const onSubmit = async ({domain, hasAlias, alias, installations}) => {
    setError(false);
    setLoading(true);
    try {
      const data = await updatePixel({
        variables: {
          input: {
            key: pixel.key,
            domain,
            alias: hasAlias ? alias : '',
            installations,
          },
        },
      });

      if (data) {
        setCompleted(true);
      }
    } catch (e) {
      setError(true);
    }
    setLoading(false);
  };

  const onCancel = () => {
    setError(false);
    setCompleted(true);
  };

  if (complete && !error) {
    return <Redirect to={createOrgPath(organization, 'manage/pixels')} />;
  }

  return (
    <ResponsiveContent containerSize='medium'>
      <CardHeader backPath={createOrgPath(organization, 'manage/pixels')}>
        Edit Pixel
      </CardHeader>
      <Card>
        {error && (
          <ToastMessage
            rules={() => ({margin: '0 0 1.5rem'})}
            alertType='error'>
            Network Error. Please Try again.
          </ToastMessage>
        )}
        <PixelForm
          pixel={pixel}
          onCancel={onCancel}
          onSubmit={onSubmit}
          loading={loading}
        />
      </Card>
    </ResponsiveContent>
  );
}
